import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'parent' ]

  connect() {
    let controller = this;

    this.$element.selectize({
      copyClassesToDropdown: false,
      valueField: controller.valueField,
      labelField: controller.labelField,
      searchField: controller.searchField,
      load: function(query, callback) {
        if (!query.length) return callback();

        $.ajax({
          url: controller.buildSearchURL(query),
          type: 'GET',
          dataType: 'json',
          error: function() {
            callback();
          },
          success: function(res) {
            callback(res.slice(0, 10));
          }
        });
      }
    });
  }

  disconnect() {
    this.element.selectize.destroy();
  }

  buildSearchURL(query) {
    let urlParts  = this.remoteUrl.split('?');
    let urlParams = new URLSearchParams(urlParts[1]);

    urlParams.append('filter[query]', query);
    return `${urlParts[0]}?${urlParams.toString()}`;
  }

  get $element() {
    return $(this.element);
  }

  get remoteUrl() {
    return this.data.get('url');
  }

  get valueField() {
    return this.data.get('value-field') || 'id';
  }

  get labelField() {
    return this.data.get('label-field') || 'name';
  }

  get searchField() {
    return this.data.get('search-field') || 'name';
  }

  get $parentTarget() {
    return $(this.parentTarget);
  }
}
